import React from 'react'
import { SidebarProvider, SidebarInset, SidebarTrigger } from '../ui/sidebar'
import { UnifiedSidebar } from '../navigation/UnifiedSidebar'
import { Separator } from '../ui/separator'

interface AdminLayoutProps {
  title?: string
  children: React.ReactNode
}

export function AdminLayout({ title, children }: AdminLayoutProps) {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex min-h-screen w-full bg-lynx">
        <UnifiedSidebar />

        <SidebarInset className="flex flex-col flex-1">
          {/* Header */}
          <header className="h-14 bg-white border-b border-stone/60 flex items-center gap-2 px-4">
            <SidebarTrigger className="md:hidden" />
            <Separator orientation="vertical" className="h-4 md:hidden" />
            <div className="flex items-center justify-between w-full">
              <div className="text-sm text-supporting truncate md:hidden">
                {title || 'Dashboard'}
              </div>
              <div className="hidden md:block text-sm text-supporting truncate">
                {title || 'Dashboard'}
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="p-4 md:p-6 flex-1">
            {title && (
              <div className="max-w-6xl mx-auto mb-3">
                <div className="text-xs text-muted-foreground">Admin</div>
                <h1 className="text-lg font-semibold text-dusk">{title}</h1>
              </div>
            )}
            <div className="max-w-6xl mx-auto">
              {children}
            </div>
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  )
}

export default AdminLayout
